module.exports = __webpack_public_path__ + "img/Finesse.2b4920f4.png";